import template from './unit.html';
import controller from './unit.controller';
import './unit.scss';

let unitComponent = {
  bindings: {},
  template,
  controller
};

export default unitComponent;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit.component.js